import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { useStaticQuery, graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
// import Search from '../Search';
import SubMenu from './subMenu';
import LinkComponent from '../../utils/linkComponent';
import ButtonComponent from '../../utils/ButtonComponent';
// const searchIndices = [
// 	{ name: `Pages`, title: `Pages` },
// 	{ name: `Sessions`, title: `Sessions` },
// 	{ name: `Speakers`, title: `Speakers` },
// ];
const StyledLink = styled((props) => <LinkComponent {...props} />)`
	font-size: var(--font-size-base);
	margin: 0em 0.7em;
	/* color: var(--secondary_2) !important; */
	padding: 10px 0px;
	color: var(--secondary_6) !important;
	text-decoration: none;
	white-space: nowrap;
	align-self: center;
	// mobile settings
	@media (max-width: 1199.5px) {
		font-weight: 600;
		margin-left: 0em;
		align-self: start;
		padding-left: 15px;
		padding-right: 15px;
		.mainMenu {
			top: 0px !important;
		}
	}
`;

const NavStyled = styled.div`
	position: sticky;
	top: -1px;
	z-index: 1000;

	.navbar-light .navbar-nav .nav-link {
		color: var(--secondary_2) !important;
		font-size: var(--font-size-base);
	}

	.mainMenu {
		/* Gradient background from #2e4d8a to #af252d */
		background: linear-gradient(to right, #2e4d8a, #af252d) !important;
		position: sticky;
		top: 0;
		height: 100px;
	}

	/* Responsive logo sizing */
	.header-logo {
		width: 35em;
		height: auto;
		image-rendering: high-quality;
		image-rendering: -webkit-optimize-contrast;
		max-width: 100%;
	}

	@media (max-width: 1200px) {
		.header-logo {
			width: 25em;
		}
	}

	@media (max-width: 768px) {
		.header-logo {
			width: 20em;
		}
		.header-logo-container {
			justify-content: center !important;
			margin-left: 0 !important;
		}
	}

	@media (max-width: 480px) {
		.header-logo {
			width: 15em;
		}
		.header-logo-container {
			justify-content: center !important;
			margin-left: 0 !important;
		}
	}

	.navbar-light .navbar-brand {
		color: var(--primary) !important;
	}

	.navbar-light .navbar-toggler {
		border-color: var(--secondary_6) !important;
		color: var(--secondary_2) !important;
	}

	/* Mobile hamburger icon padding */
	@media (max-width: 768px) {
		.navbar-light .navbar-toggler {
			margin-right: 15px !important;
		}
	}
	.navItem {
		color: var(--secondary_6) !important;
	}
	.navItem:hover {
		color: var(--light_overlay) !important;
		text-decoration: none;
	}
	.navbar-toggler-icon {
		background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 255)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
	}

	.navbar-toggler:focus {
		box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width) var(--secondary_6);
	}

	// tablets settings
	@media (max-width: 1199.5px) {
		.navItem {
			border-bottom: 1px solid #ccc !important;
			border-radius: 0px;
			padding: 10px 15px;
			width: 100%;
		}
		.btn-primary {
			margin: 10px 0px !important;
			margin-left: 15px !important;
		}
	}
	// mobile settings
	@media (max-width: 768px) {
		.navItem {
			border-bottom: 1px solid #ccc !important;
			border-radius: 0px;
			padding: 10px 15px;
			width: 100%;
		}
		.btn-primary {
			margin: 10px 0px !important;
			margin-left: 15px !important;
		}
		.navbar-collapse {
			/* Apply the same gradient background to mobile menu */
			background: linear-gradient(to right, #2e4d8a, #af252d) !important;
			padding-left: 15px;
			padding-right: 15px;
			margin-left: -15px;
			margin-right: -15px;
			width: calc(100% + 30px);
		}
		.container {
			padding-left: 0;
			padding-right: 0;
		}
	}
`;

const Header = () => {
	const [expanded, setExpanded] = useState(false);
	const menuData = useStaticQuery(graphql`
		query menuQuery {
			allStrapiNavigationPluginMainNavigation(sort: { order: ASC }) {
				nodes {
					items {
						path
						title
						type
						sub_menu_icon
						items {
							path
							title
							type
						}
					}
					order
					title
					type
					path
				}
			}
		}
	`);

	return (
		<NavStyled>
			<Navbar
				variant='light'
				fixed='top'
				expand='xl'
				className='mainMenu'
				collapseOnSelect
				expanded={expanded}
				onToggle={() => setExpanded((expanded) => !expanded)}
			>
				<Container>
					<Navbar.Brand
						onClick={() => {
							setExpanded(false);
							navigate('/');
						}}
						style={{ cursor: 'pointer' }}
					>
						<div
							className='header-logo-container'
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'flex-start',
								gap: '0.5em',
								marginLeft: '-5em',
							}}
						>
							<LinkComponent to={`/`}>
								<StaticImage
									src='../../images/Stronger Together Logo Layup Updated.png'
									alt='Stronger Together Logo Layup Updated'
									loading='lazy'
									className='header-logo'
								/>
							</LinkComponent>
						</div>
					</Navbar.Brand>
					<Navbar.Toggle aria-controls='basic-navbar-nav' />
					<Navbar.Collapse id='basic-navbar-nav'>
						<Nav className='ms-auto'>
							{/* <Search setExpanded={setExpanded} indices={searchIndices} /> */}
							{/* Adding a multilevel navbar with dropdowns */}
							{menuData.allStrapiNavigationPluginMainNavigation.nodes.map(
								(menuItem) =>
									menuItem.items?.length > 0 ? (
										<SubMenu
											key={menuItem.title}
											setExpanded={setExpanded}
											menuItem={menuItem}
											className='navItem'
										></SubMenu>
									) : (
										<StyledLink
											onClick={() => setExpanded(false)}
											className='navItem'
											to={menuItem.path}
											key={menuItem.title}
										>
											{menuItem.title}
										</StyledLink>
									)
							)}
							<LinkComponent
								to={`/registration`}
								onClick={() => setExpanded(false)}
							>
								<ButtonComponent buttonName='Register'></ButtonComponent>
							</LinkComponent>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</NavStyled>
	);
};
export default Header;
